import React from 'react';
import Button from '../../../../components/buttons/Button';
import { useSheetContext } from '../SheetContextProvider';

import './SheetMenu.scss';

export type SheetMenuItem = {
    label: string;
    icon?: React.ReactNode;
    onClick: (event: React.MouseEvent) => void;
    dismissSheetOnSelect?: boolean;
    visible?: boolean; // defaults to true
};

export type SheetMenuProps = {
    footer?: React.ReactNode;
    menuItems: SheetMenuItem[];
};

const SheetMenu = ({ footer, menuItems }: SheetMenuProps) => {
    const { dispatchCloseSheet } = useSheetContext();

    return (
        <ul className="SheetMenu">
            {menuItems
                .filter((item) => item.visible !== false)
                .map((item) => (
                    <li key={item.label}>
                        <Button
                            onClick={(event) => {
                                event.preventDefault();
                                item.onClick(event);

                                if (item.dismissSheetOnSelect) {
                                    dispatchCloseSheet();
                                }
                            }}
                        >
                            {item.icon}
                            <span>{item.label}</span>
                        </Button>
                    </li>
                ))}
            {footer && <li>{footer}</li>}
        </ul>
    );
};

export default SheetMenu;
